<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import Swal from "sweetalert2";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "BuyEducations",
  components: {FooterPage, NavbarPage, LoadingPage},

  setup(){
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let educations = ref([])


    function load_educations() {

      loading.value = true
      FreeWorld.Heisenberg({} , 'educations_user' , true).then((result)=>{

        loading.value = false
        let res = result.data
        educations.value = res

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_educations()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_educations()
            }
          })
        }
      })


    }
    load_educations()

    return{

      loading,
      educations,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">آموزش های خریداری شده</p>

        <div onclick="window.history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="educations.length == 0" class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-4 ">
          در حال حاضر محصولی وجود ندارد...
        </p>
      </div>
    </div>


    <div v-else class="p-body mt-2">

      <router-link v-for="item in educations" :key="item.id" class="animate__animated animate__fadeIn rounded-shaped d-flex flex-row-reverse justify-content-between text-black text-decoration-none mb-2 py-3 rounded-4 shadow-costom p-body"
                   :to="{name:'DetailsEducation' , params:{id:item.id}}">

        <div class="div_img_products rounded-4 animated-background position-relative ">
          <img class="img_products rounded-4" :src="item.profile_pic" alt="">
        </div>

        <div class="information_products">

          <p class="font-4 font-bold ">{{ item.education_name }}</p>

          <p class="font-4 d-flex">
            <span>{{ item.length }}</span>
            &nbsp;
            <span>
           ساعت
         </span>
          </p>
          <hr>
          <div class="price_div d-flex justify-content-between align-items-center">

            <div class="d-flex">

              <p class="m-0 ml-1" :class="item.off_price == null ? 'font-color font-4' : 'text-decoration-line-through font-5' ">
                <span class="ml-1">{{ parseInt(item.price).toLocaleString() }}</span>
                <span v-if="item.off_price == null " class="">تومان</span>
              </p>

              <p v-if="item.off_price != null" class="font-4 font-color m-0 ml-1">
                <span class="ml-1">{{ parseInt(item.off_price).toLocaleString() }}</span>
                <span class="">تومان</span>
              </p>

            </div>

            <p v-if="item.off_price != null && item.discount != 0 " class="off_percent font-6 rounded-pill font-color p-1 m-0">
              <span>{{ item.discount }}</span>
              <span>%</span>
            </p>
          </div>
        </div>

      </router-link>

    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">آموزش های خریداری شده</div>

    <div class="p-4 w-75 bg-white rounded-4 m-auto">
    <div v-if="educations.length == 0" class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-4 ">
          در حال حاضر محصولی وجود ندارد...
        </p>
      </div>
    </div>

    <div v-else class="">

      <router-link v-for="item in educations" :key="item.id" class="animate__animated animate__fadeIn rounded-shaped d-flex flex-row-reverse justify-content-between text-black text-decoration-none mb-2 py-3 rounded-4 shadow-costom p-body"
                   :to="{name:'DetailsEducation' , params:{id:item.id}}">

        <div class="div_img_products rounded-4 animated-background position-relative ">
          <img class="img_products rounded-4" :src="item.profile_pic" alt="">
        </div>

        <div class="information_products">

          <p class="font-4 font-bold ">{{ item.education_name }}</p>

          <p class="font-4 d-flex">
            <span>{{ item.length }}</span>
            &nbsp;
            <span>
           ساعت
         </span>
          </p>
          <hr>
          <div class="price_div d-flex justify-content-between align-items-center">

            <div class="d-flex">

              <p class="m-0 ml-1" :class="item.off_price == null ? 'font-color font-4' : 'text-decoration-line-through font-5' ">
                <span class="ml-1">{{ parseInt(item.price).toLocaleString() }}</span>
                <span v-if="item.off_price == null " class="">تومان</span>
              </p>

              <p v-if="item.off_price != null" class="font-4 font-color m-0 ml-1">
                <span class="ml-1">{{ parseInt(item.off_price).toLocaleString() }}</span>
                <span class="">تومان</span>
              </p>

            </div>

            <p v-if="item.off_price != null && item.discount != 0 " class="off_percent font-6 rounded-pill font-color p-1 m-0">
              <span>{{ item.discount }}</span>
              <span>%</span>
            </p>
          </div>
        </div>

      </router-link>

    </div>
  </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.img_products {
  width: 100%;
  height: 122px;
}

.div_img_products {
  width: 10rem;
  height: 10rem;
  margin-left: 10px;
}

.information_products{
  width: 62%;
  direction: rtl;
}

.off_percent {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d2d2d2;
}

</style>